import FormCategoryService from 'src/modules/formCategory/formCategoryService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'FORMCATEGORY_VIEW';

const formCategoryViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryViewActions.FIND_STARTED,
      });

      const record = await FormCategoryService.find(id);

      dispatch({
        type: formCategoryViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formCategoryViewActions.FIND_ERROR,
      });

      getHistory().push('/form-category');
    }
  },
};

export default formCategoryViewActions;
